declare let STEPSTONE_PROPERTY_HOST: string;

import { IConfig } from './IConfig';
import { PropertyConfig } from './PropertyConfig';
import { StepstoneConfig } from './StepstoneConfig';

class Configuration {
  private profileConfigs: IConfig[] = [];

  public GetProfileConfigs = (): IConfig[] => {
    return this.profileConfigs;
  };

  private getStepstonePropertyDomain = () => {
    if (typeof STEPSTONE_PROPERTY_HOST !== undefined) return STEPSTONE_PROPERTY_HOST;
    throw new Error('host not defined');
  };

  constructor() {
    const propertyDomain = this.getStepstonePropertyDomain();

    this.profileConfigs = [
      new StepstoneConfig('uk', ['en']),
      new StepstoneConfig('de', ['de', 'en']),
      new StepstoneConfig('at', ['de', 'en']),
      new StepstoneConfig('fr', ['fr', 'en']),
      new StepstoneConfig('be', ['en', 'nl', 'fr']),
      new StepstoneConfig('nl', ['nl', 'en']),
      new StepstoneConfig('pnet', ['en'], 'za'),
      new PropertyConfig('bild', ['de'], propertyDomain),
      new PropertyConfig('spiegel', ['de'], propertyDomain),
      new PropertyConfig('berlin', ['de'], propertyDomain),
    ];
  }
}

let ProfileConfigs: IConfig[] = [];

try {
  const instance = new Configuration();
  ProfileConfigs = instance.GetProfileConfigs();
} catch {}

export { ProfileConfigs, Configuration };
